export default "__VITE_ASSET__d84d22be__"